import { useState, useEffect, useCallback, useRef, useContext, useMemo } from 'react'
import { useMutation, useLazyQuery } from "@apollo/client";
import { useNavigate, useParams } from "react-router";
import { useDisclosure, useMediaQuery, useToast } from "@chakra-ui/react";
import {
    PRODUCT_CONTENT,
    DYNOESCOUNT,
    MYDYNOES
} from "../../graphql/queries";
import {
    CREATE_PRODUCT_CONTENT,
    UPDATE_DYNO_LIST,
    DELETE_DYNO_LIST,
    UPDATE_DYNO,
    UPDATE_PRODUCT,
    UPDATE_MANY_DYNOES,
    DELETE_DYNO_FROM_LIST,
    LOCKUNLOCKALLDYNOS,
    ADD_DYNOS_TO_LIST,
    CREATE_AI_CHAPTERS,
    CREATE_PDF_DYNO,
    CREATE_VIDEO_DYNO,
    CREATE_PRODUCT_SUBSCRIPTION_PLAN,
    CREATE_PRODUCT_ONE_TIME_PLAN
} from "../../graphql/mutations";
import { REMOVED, USD, SUBSCRIPTION, ONETIMEPURCHASE, INPROGRESS } from "../../constants";
import { PublisherAndUserContext } from '../../contexts/PublisherAndUserContext';

let PageSize = 10;
export const useContent = () => {
    const { user, publisher } = useContext(PublisherAndUserContext);
    const [catalogs, setCatalogs] = useState([]);
    const [productId, setProductId] = useState("");
    const [listTitle, setListTitle] = useState({ id: "", listTitle: "" });
    const [publishStatus, setPublishStatus] = useState(false);
    const [canProductBePublished, setCanProductBePublished] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [showViewer, setShowViewer] = useState(false);
    const [media, setMedia] = useState({});
    const [listId, setListId] = useState("");
    const [loading, setLoading] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const [dynoes, setDynoes] = useState([]);
    const [totalDynoes, setTotalDynoes] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [searchText, setSearchText] = useState("");
    const [searchedDynoes, setSearchedDynoes] = useState([]);
    const productRef = useRef({});
    const listRef = useRef()
    const navigate = useNavigate()
    const toast = useToast();
    const [product, setProduct] = useState({
        id: "",
        productName: "",
        productStatus: "",
        productContent: {
            id: "",
            dynoList: [
                {
                    id: "",
                    listName: "",
                    listTitle: "",
                    dynosUnderList: [],
                },
            ],
        },
        productAdmins: [],
    });
    const [dynosToAdd, setDynosToAdd] = useState([]);
    const [pricePlan, setPricePlan] = useState({
        type: "Subscription",
        frequency: "Yearly",
        price: null
    });
    const [mergeDyno, setMergeDyno] = useState({
        dyno1: "",
        dyno2: "",
        dynoTitle: "",
        error: "",
    });
    const [iPadPortrait] = useMediaQuery("(max-width: 1024px)");
    const { isOpen, onClose, onOpen } = useDisclosure();
    const {
        isOpen: isDynoModalOpen,
        onClose: onDynoModalClose,
        onOpen: onDynoModalOpen,
    } = useDisclosure();
    const {
        isOpen: isAddMediaModalOpen,
        onOpen: onAddMediaModalOpen,
        onClose: onAddMediaModelClose,
    } = useDisclosure();
    const {
        isOpen: isOpenAddPlan,
        onOpen: onOpenAddPlan,
        onClose: onCloseAddPlan,
    } = useDisclosure();
    const { id: product_Id } = useParams();

    const [getProductDetails] = useLazyQuery(PRODUCT_CONTENT, {
        onCompleted: (data) => {
            setLoading(false)
            if (!data.product.productContent) {
                const prdt = {
                    ...data.product,
                    productContent: {
                        id: "",
                        dynoList: [],
                    },
                };
                productRef.current = prdt
                setProduct(prdt);
            } else {
                const prodt = {
                    ...data.product,
                    productContent: {
                        ...data.product.productContent,
                        dynoList: data.product.productContent.dynoList
                            .map((list, lindex) => ({
                                ...list,
                                listIndex:
                                    typeof list.listIndex === "object"
                                        ? lindex + 1
                                        : list.listIndex === lindex + 2
                                            ? lindex + 1
                                            : list.listIndex,
                            }))
                            .map((list) => ({
                                ...list,
                                dynosUnderList: list.dynosUnderList.map(
                                    (dynoUnderList, dindex) => ({
                                        ...dynoUnderList,
                                        index:
                                            typeof dynoUnderList.index === "object"
                                                ? dindex + 1
                                                : dynoUnderList.index === dindex + 2
                                                    ? dindex + 1
                                                    : dynoUnderList.index,
                                    })
                                ),
                            })),
                    },
                }
                setProduct(prodt);
                productRef.current = prodt
                if (
                    data.product.productContent &&
                    data.product.productContent.dynoList.length > 0
                ) {
                    for (let list of data.product.productContent.dynoList) {
                        let dynoId = "";
                        for (let dl of list.dynosUnderList) {
                            if (dl.dyno) {
                                setShowViewer(true);
                                dynoId = dl.dyno.id;
                                break;
                            }
                        }
                        if (dynoId !== "") {
                            break;
                        }
                    }
                    const dynoes = data?.product?.productContent?.dynoList
                        .map((dl) => dl.dynosUnderList.map((dul) => dul.dyno).flat())
                        .flat();
                    if (dynoes.length > 0) {
                        setMergeDyno({
                            ...mergeDyno,
                            dyno1: dynoes[0].id,
                            dyno2: dynoes.length > 1 ? dynoes[1].id : dynoes[0].id,
                        });
                    }
                }
                setCanProductBePublished(
                    checkCanProductBePublished(data.product.productContent.dynoList)
                );
            }
            setIsAdmin(publisher.owner.id === user.id ? true : !!data.product.catalog.catalogAdmins.find(
                (admin) => admin.id === user.id
            ) ? !!data.product.catalog.catalogAdmins.find(
                (admin) => admin.id === user.id
            ) : !!data.product.productAdmins.find(
                (admin) => admin.id === user.id
            )
            )
            setPublishStatus(data.product.productStatus === "Offline" ? false : true);
            setShowButton(data.product?.productContent?.dynoList?.length !== 0 && data.product?.productContent?.dynoList?.map(dl => dl.dynosUnderList).flat().length !== 0)
        },
        onError: () => {
            setLoading(false)
        },
        fetchPolicy: "no-cache",
    });

    const [searchMyDynoes, { loading: searchMyDynoesLoading }] = useLazyQuery(
        MYDYNOES,
        {
          onCompleted: (data) => {
            const dynoesRes = data.dynoes;
            setSearchedDynoes(dynoesRes);
          },
          notifyOnNetworkStatusChange: true,
          onError: () => {
            console.log("error while fetching or searching EdDoc.");
          },
          fetchPolicy: "no-cache",
        }
    );

    const onPageChange = (page) => {
        if (!dynoes[(page - 1) * 10]) {
          myDynoesFetchMore({
            variables: {
              take: 10,
              skip: Math.round(page * 10) - 10,
            },
          });
        }
        setCurrentPage(page);
      };

    const [getDynoes, { loading: myDynoesLoading, fetchMore: myDynoesFetchMore }] = useLazyQuery(MYDYNOES, {
        onCompleted: (data) => {
            const dynoesRes = data.dynoes;
            if (currentPage > 1) {
                const allDynoes = [...dynoes];
                const index = currentPage * 10 - 10;
                allDynoes.splice(index, 10, ...dynoesRes);
                setDynoes(allDynoes);
            } else {
                const dynoesInit = new Array(totalDynoes);
                dynoesInit.splice(0, 10, ...dynoesRes);
                setDynoes(dynoesInit);
             }
        },
        notifyOnNetworkStatusChange: true,
        onError: () => {
            console.log("error while fetching or searching EdDoc.");
        },
        fetchPolicy: "cache-and-network",
        nextFetchPolicy: "cache-first",
    });

    const [getDynoesCount] = useLazyQuery(DYNOESCOUNT, {
        onCompleted: (data) => {
            if (data.findDynoCount) {
                setTotalDynoes(data.findDynoCount);
                getDynoes({
                    variables: {
                        take: 10,
                        skip: 0,
                        orderBy: {
                            createdAt: "desc",
                        },
                        where: {
                            dynoPublishingStatus: {
                                equals: INPROGRESS
                            },
                            owner: {
                                id: {
                                    equals: user.id,
                                },
                            },
                        },
                    },
                });
            }
        },
        fetchPolicy: "no-cache",
    });

    const [createAIChapters] = useMutation(CREATE_AI_CHAPTERS, {
        onCompleted: async (data) => {
            let chapterNames = JSON.parse(data.edshopifyCreateAIChapters)
            chapterNames = chapterNames.map(cn => ({ listName: cn, listTitle: cn }))
            const chapters = {
                create: {
                    dynoList: {
                        create: chapterNames,
                    },
                },
            }
            await createProductContent({
                variables: {
                    where: {
                        id: productId,
                    },
                    data: {
                        productContent: {
                            ...chapters,
                        },
                    },
                },
            });
        },
        onError: () => {
            setLoading(false)
        },
    });

    const checkCanProductBePublished = (dynoList) => {
        let canProductBePublished = true;
        const dynoes = [];
        for (let list of dynoList) {
            for (let listDyno of list.dynosUnderList) {
                dynoes.push(listDyno.dyno);
            }
        }
        if (dynoes.length === 0) return false;
        for (let dyno of dynoes) {
            if (dyno.dynoPublishingStatus !== "VerifiedByQA" && dyno.dynoPublishingStatus !== "AddedToProductLine") {
                canProductBePublished = false;
                break;
            }
        }
        return canProductBePublished;
    };

    const [createProductContent] = useMutation(CREATE_PRODUCT_CONTENT, {
        onCompleted: (data) => {
            let dynoList = [...product.productContent.dynoList];
            dynoList = [...dynoList, ...data.updateProduct.productContent.dynoList]
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: dynoList,
                },
            });
            setShowButton(dynoList?.length !== 0 && dynoList?.map(dl => dl.dynosUnderList).flat().length !== 0)
            const dynoes = data?.updateProduct?.productContent?.dynoList
                .map((dl) => dl.dynosUnderList.map((dul) => dul.dyno).flat())
                .flat();
            if (dynoes.length > 0) {
                setMergeDyno({
                    ...mergeDyno,
                    dyno1: dynoes[0].id,
                    dyno2: dynoes.length > 1 ? dynoes[1].id : dynoes[0].id,
                });
            }
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [deleteDynoFromList] = useMutation(DELETE_DYNO_FROM_LIST, {
        onCompleted: (data) => {
            const dyno = data.deleteDynoFromList.dyno;
            const dynoList = [...product.productContent.dynoList];
            const listIndex = dynoList.findIndex(
                (list) => list.id === data.deleteDynoFromList.listId
            );
            if (listIndex > -1) {
                const dynosUnderList = dynoList[listIndex].dynosUnderList.filter(
                    (listDyno) => listDyno.dyno.id !== dyno.id
                );
                dynoList[listIndex] = {
                    ...dynoList[listIndex],
                    dynosUnderList: dynosUnderList,
                };
                setProduct({
                    ...product,
                    productContent: {
                        ...product.productContent,
                        dynoList: dynoList,
                    },
                });
                setShowButton(dynoList?.length !== 0 && dynoList?.map(dl => dl.dynosUnderList).flat().length !== 0)
            }
            setCanProductBePublished(checkCanProductBePublished(dynoList));
            setLoading(false)
        },
        error: () => {
            setLoading(false)
        },
    });

    const [updateProduct] = useMutation(UPDATE_PRODUCT, {
        onCompleted: (data) => {
            setProduct({
                ...product,
                productStatus: data.updateProduct.productStatus,
            });
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [archiveProductItem] = useMutation(UPDATE_PRODUCT, {
        onCompleted: (data) => {
            setLoading(false)
            toast({
                position: "top-right",
                title: `Archived ${data.updateProduct.productName}`,
                status: "success",
                duration: 2000,
                isClosable: true,
            });
            navigate(`/catalog/${data.updateProduct.catalogId}`)
        },
        onError: () => {
            setLoading(false)
        },
    })

    const [addToStoreItem] = useMutation(UPDATE_PRODUCT, {
        onCompleted: (data) => {
            setLoading(false)
            toast({
                position: "top-right",
                title: `${data.updateProduct.isAddedToStore ? `Added ${data.updateProduct.productName} to store.` : `Removed ${data.updateProduct.productName} from store.`} `,
                status: "success",
                duration: 2000,
                isClosable: true,
            });
            navigate(`/catalog/${data.updateProduct.catalogId}`)
        },
        onError: () => {
            setLoading(false)
        },
    })

    const [updateManyDynoes] = useMutation(UPDATE_MANY_DYNOES, {
        onCompleted: (data) => {
            let dynoList = product.productContent.dynoList;
            const status = publishStatus ? "AddedToProductLine" : "VerifiedByQA";
            dynoList = dynoList.map((list) => ({
                ...list,
                dynosUnderList: list.dynosUnderList.map((listDyno) => ({
                    ...listDyno,
                    dyno: {
                        ...listDyno.dyno,
                        dynoPublishingStatus: status,
                    },
                })),
            }));
            setProduct({
                ...product,
                productStatus: publishStatus ? "Published" : "Offline",
                productContent: {
                    ...product.productContent,
                    dynoList: dynoList,
                },
            });
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
            toast({
                position: "top-right",
                title: "Failed to update. Please try again in somtime.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        },
    });

    const [updateDyno] = useMutation(UPDATE_DYNO, {
        onCompleted: (data) => {
            const dyno = data.updateDyno;
            const dynoList = [...product.productContent.dynoList];
            const listIndex = dynoList.findIndex((list) =>
                list.dynosUnderList.find(
                    (dynoUnderList) => dynoUnderList.dyno.id === dyno.id
                )
            );
            if (listIndex > -1) {
                const dynosUnderList = dynoList[listIndex].dynosUnderList.map(
                    (listDyno) => {
                        if (listDyno.dyno.id === dyno.id) {
                            return {
                                ...listDyno,
                                dyno: {
                                    ...listDyno.dyno,
                                    accessType: dyno.accessType,
                                    dynoPublishingStatus: dyno.dynoPublishingStatus,
                                },
                            };
                        }
                        return listDyno;
                    }
                );
                dynoList[listIndex] = {
                    ...dynoList[listIndex],
                    dynosUnderList: dynosUnderList,
                };
                setProduct({
                    ...product,
                    productContent: {
                        ...product.productContent,
                        dynoList: dynoList,
                    },
                });
            }
            setCanProductBePublished(checkCanProductBePublished(dynoList));
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [updateDynoList] = useMutation(UPDATE_DYNO_LIST, {
        onCompleted: (data) => {
            setLoading(false)
            const newDynoList = [...product.productContent.dynoList];
            const index = newDynoList.findIndex(
                (list) => list.id === data.updateDynoList.id
            );
            newDynoList[index] = {
                ...newDynoList[index],
                listTitle: data.updateDynoList.listTitle,
                listName: data.updateDynoList.listTitle,
            };
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: newDynoList,
                },
            });
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [updateDynoListValue] = useMutation(UPDATE_DYNO_LIST, {
        onCompleted: (data) => {
            const newDynoList = [...product.productContent.dynoList];
            const index = newDynoList.findIndex(
                (list) => list.id === data.updateDynoList.id
            );
            const updatedDynosUnderList = [...data.updateDynoList.dynosUnderList];
            const dynosUnderList = [...newDynoList[index].dynosUnderList];
            for (let dynoList of updatedDynosUnderList) {
                const dynIndex = dynosUnderList.findIndex(
                    (dynList) => dynList.id === dynoList.id
                );
                if (dynIndex > -1) {
                    dynosUnderList[dynIndex] = {
                        ...dynosUnderList[dynIndex],
                        index: dynoList.index,
                        isLocked: dynoList.isLocked,
                    };
                }
            }
            newDynoList[index] = {
                ...newDynoList[index],
                dynosUnderList: dynosUnderList,
            };
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: newDynoList,
                },
            });
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [lockUnlockAllDynoInProduct] = useMutation(LOCKUNLOCKALLDYNOS, {
        onCompleted: (data) => {
            if (
                !!data.lockUnlockAllDynoInProduct &&
                data.lockUnlockAllDynoInProduct.productContent.dynoList.length > 0
            ) {
                const isLocked =
                    data.lockUnlockAllDynoInProduct.productContent.dynoList[0]
                        .dynosUnderList[0].isLocked;
                let dynoList = [...product.productContent.dynoList];
                dynoList.forEach((dl, index) => {
                    const dynosUnderList = dl.dynosUnderList.map((dul) => ({
                        ...dul,
                        isLocked: isLocked,
                    }));
                    dynoList[index] = { ...dl, dynosUnderList: dynosUnderList };
                });
                setProduct({
                    ...product,
                    productContent: {
                        ...product.productContent,
                        dynoList: dynoList,
                    },
                });
            }
            setLoading(false)
        },
        onError: () => {
            setLoading(false)
        },
    });

    const [deleteDynoList] = useMutation(DELETE_DYNO_LIST, {
        onCompleted: (data) => {
            setLoading(false)
            const newDynoList = product.productContent.dynoList.filter(
                (list) => list.id !== data.deleteDynoList.id
            );
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: newDynoList,
                },
            });
            setShowButton(newDynoList?.length !== 0 && newDynoList?.map(dl => dl.dynosUnderList).flat().length !== 0)
            toast({
                position: "top-right",
                title: `Deleted ${data.deleteDynoList.dynoTitle}`,
                status: "success",
                duration: 2000,
                isClosable: true,
            });
        },
        onError: (e) => {
            setLoading(false)
            toast({
                position: "top-right",
                title: "Failed to delete. Please try again.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const [createPdfDyno] = useMutation(CREATE_PDF_DYNO, {
        onCompleted: (data) => {
            const newDynoList = [...product.productContent.dynoList];
            const index = newDynoList.findIndex(
                (list) => list.id === data.edshopifyCreatePdfDyno.otherInfo.dynoList.id
            );
            newDynoList[index] = {
                ...newDynoList[index],
                dynosUnderList: data.edshopifyCreatePdfDyno.otherInfo.dynoList.dynosUnderList,
            };
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: newDynoList,
                },
            });
            setLoading(false)
            setMedia({})
            onAddMediaModelClose()
        },
        onError: () => {
            setLoading(false)
            toast({
                position: "top-right",
                title: "Failed to create Eddoc. Please try again in somtime.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        },
    });

    const [createVideoDyno] = useMutation(CREATE_VIDEO_DYNO, {
        onCompleted: (data) => {
            const newDynoList = [...product.productContent.dynoList];
            const index = newDynoList.findIndex(
                (list) => list.id === data.edshopifyCreateVideoDyno.otherInfo.dynoList.id
            );
            newDynoList[index] = {
                ...newDynoList[index],
                dynosUnderList: data.edshopifyCreateVideoDyno.otherInfo.dynoList.dynosUnderList,
            };
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: newDynoList,
                },
            });
            setLoading(false)
            setMedia({})
            onAddMediaModelClose()
        },
        onError: () => {
            setLoading(false)
            toast({
                position: "top-right",
                title: "Failed to create Eddoc. Please try again in somtime.",
                status: "error",
                duration: 3000,
                isClosable: true,
            });
        },
    });

    const [addDynosToList] = useMutation(ADD_DYNOS_TO_LIST, {
        onCompleted: (data) => {
            setLoading(false)
            const dynoListCopy = [...product.productContent.dynoList];
            const index = dynoListCopy.findIndex(
                (list) => list.id === data.addDynosToList.id
            );
            dynoListCopy[index] = {
                ...dynoListCopy[index],
                dynosUnderList: data.addDynosToList.dynosUnderList,
            };
            setProduct({
                ...product,
                productContent: {
                    ...product.productContent,
                    dynoList: dynoListCopy,
                },
            });
            setShowButton(dynoListCopy?.length !== 0 && dynoListCopy?.map(dl => dl.dynosUnderList).flat().length !== 0)
            setDynosToAdd([])
            toast({
                position: "top-right",
                title: "Added to module.",
                status: "success",
                duration: 2000,
                isClosable: true,
            });
            onDynoModalClose();
        },
        onError: () => {
            setLoading(false)
            toast({
                position: "top-right",
                title: "Failed to add EdDoc. Please try again.",
                status: "error",
                duration: 2000,
                isClosable: true,
            });
        },
    });

    const [createProductSubscription] = useMutation(
        CREATE_PRODUCT_SUBSCRIPTION_PLAN,
        {
            onCompleted: (data) => {
                setProduct({...product, productPricingType: SUBSCRIPTION})
                setLoading(false)
                onCloseAddPlan()
                toast({
                    position: "top-right",
                    title: "Successfully created subscription price.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
            },
            onError: () => {
                setLoading(false)
                toast({
                    position: "top-right",
                    title: "Failed to create subscription price. Please try again.",
                    status: "error",
                    duration: 2000,
                    isClosable: true,
                });
            },
        }
    );

    const [createProductOneTimePlan] = useMutation(
        CREATE_PRODUCT_ONE_TIME_PLAN,
        {
            onCompleted: (data) => {
                setProduct({...product, productPricingType: ONETIMEPURCHASE})
                setLoading(false)
                onCloseAddPlan()
                toast({
                    position: "top-right",
                    title: "Successfully created price.",
                    status: "success",
                    duration: 2000,
                    isClosable: true,
                });
                
            },
            onError: (err) => {
                setLoading(false)
                toast({
                    position: "top-right",
                    title: "Failed to create one time price. Please try again.",
                    status: "error",
                    duration: 3000,
                    isClosable: true,
                });
            },
        }
    );

    useEffect(() => {
        if (product_Id && user?.id) {
            setProductId(product_Id);
            setLoading(true)
            getProductDetails({
                variables: {
                    where: {
                        id: product_Id,
                    },
                },
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [product_Id, user.id]);

    const createAIChaptersName = (productName) => {
        setLoading(true)
        createAIChapters({
            variables: {
                where: {
                    id: publisher?.id
                },
                data: {
                    title: productName
                }
            }
        })
    }
    const createNewChapter = () => {
        setLoading(true)
        let data =
            product.productContent && product.productContent.id
                ? {
                    update: {
                        dynoList: {
                            create: [
                                {
                                    listIndex: product.productContent.dynoList.length + 1,
                                    listName: "New Module",
                                    listTitle: "New Module",
                                },
                            ],
                        },
                    },
                }
                : {
                    create: {
                        dynoList: {
                            create: [
                                {
                                    listName: "New Module",
                                    listTitle: "New Module",
                                },
                            ],
                        },
                    },
                };
        createProductContent({
            variables: {
                where: {
                    id: productId,
                },
                data: {
                    productContent: {
                        ...data,
                    },
                },
            },
        });
    };

    const onAddMediaClose = () => {
        setMedia({})
        onAddMediaModelClose()
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            if (listTitle.id !== "" && listTitle.listTitle !== "") {
                updateDynoList({
                    variables: {
                        where: {
                            id: listTitle.id,
                        },
                        data: {
                            listName: { set: listTitle.listTitle },
                        },
                    },
                });
            }
        }, 400);
        return () => {
            clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [listTitle]);

    const editCallback = useCallback((id, value) => {
        setListTitle({ id: id, listTitle: value });
    }, []);

    const deleteCallback = useCallback((id, name) => {
        setLoading(true)
        deleteDynoList({
            variables: {
                where: {
                    id: id,
                },
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const createMediaDynoCallback = useCallback((media) => {
        setLoading(true)
        if (media.type === "application/pdf") {
            createPdfDyno({
                variables: {
                    where: {
                        id: publisher.id,
                        listId: listRef.current
                    },
                    data: {
                        dynoTitle: media.name.replace(/\.pdf$/, ""),
                        dynoType: "Reading",
                        pdf: {
                            fileSize: media.size.toString(),
                            uploadMethod: "url",
                            src: media.url,
                            fileName: media.name.replace(/\.pdf$/, "")
                        },
                        productId: product?.id ? product?.id : product_Id
                    }
                },
            });
            return true
        }
        return createVideoDyno({
            variables: {
                where: {
                    id: publisher.id,
                    listId: listRef.current
                },
                data: {
                    dynoType: "Video",
                    videoList: {
                        dynoTitle: media.name.split(".")[0],
                        videoTitle: media.name,
                        link: media.url,
                        sequence: 0,
                        language: "en",
                        videoDescription: media.description,
                        vimeoId: media.id
                    },
                    productId: product?.id ? product?.id : product_Id
                }
            },
        });
    }, [publisher]);

    const deleteDynoCallback = (list_id, id, dyno) => {
        setLoading(true)
        deleteDynoFromList({
            variables: {
                data: {
                    status: INPROGRESS,
                },
                where: {
                    listId: list_id,
                    dynosUnderListId: id,
                    dynoId: dyno.id,
                    productId: product.id,
                },
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    const openAddDynoModal = (list_id) => {
        setListId(list_id);
        getDynoesCount({
            variables: {
            where: {
                owner: {
                id: {
                    equals: user.id,
                },
                },
            },
            },
        });
        onDynoModalOpen();
    };

    const onMediaModalOpen = (list_id) => {
        listRef.current = list_id
        onAddMediaModalOpen();
    };

    const selectMedia = (type, pdf, video) => {
        if (type === "pdf") {
            setMedia(pdf)
        } else {
            setMedia(video)
        }
    }

    const checkOnChange = (e) => {
        const val = JSON.parse(e.target.value)
        setDynosToAdd(
            e.target.checked
                ? [
                    ...dynosToAdd,
                    {
                        id: val.id,
                        dynoType: val.dynoType.name,
                        dynoTitle: val.dynoTitle,
                    },
                ]
                : dynosToAdd.filter((dyno) => dyno.id !== val.id)
        );
    };

    const addDynoToList = () => {
        const where = {
            listId: listId,
            productId: product.id,
        };
        const dynoList = product.productContent.dynoList.find(
            (list) => list.id === listId
        );
        const data = {
            startIndex: dynoList.dynosUnderList.length + 1,
            dynoes: dynosToAdd,
        };
        setLoading(true)
        addDynosToList({
            variables: {
                where,
                data,
            },
        });
    };

    const updatDynoStatusCallback = useCallback(
        (status, id) => {
            setLoading(true)
            updateDyno({
                variables: {
                    where: {
                        id: id,
                    },
                    data: {
                        dynoPublishingStatus: { set: status },
                    },
                },
            });
        },
        [updateDyno]
    );

    const updatDynoAccessType = useCallback(
        (id, accessType) => {
            setLoading(true)
            updateDyno({
                variables: {
                    where: {
                        id: id,
                    },
                    data: {
                        accessType: { set: accessType },
                    },
                },
            });
        },
        [updateDyno]
    );

    const updateDynoListCallback = useCallback(
        (list_id, listData) => {
            updateDynoListValue({
                variables: {
                    where: {
                        id: list_id,
                    },
                    data: {
                        dynosUnderList: {
                            update: listData.map((lData) => ({
                                where: { id: lData.id },
                                data: { index: { set: lData.index } },
                            })),
                        },
                    },
                },
            });
        },
        [updateDynoListValue]
    );

    const lockUnlockAllDyno = (isLocked) => {
        setLoading(true)
        lockUnlockAllDynoInProduct({
            variables: {
                where: {
                    productId: product.id,
                    isLocked: isLocked,
                },
            },
        });
    };

    const publishProduct = () => {
        if (canProductBePublished) {
            // publish statement
            setLoading(true)
            setPublishStatus(product.productStatus === "Offline" ? true : false);
            let dynoes = [];
            for (let list of product.productContent.dynoList) {
                dynoes.push(...list.dynosUnderList.map((listDyno) => listDyno.dyno.id));
            }
            updateProduct({
                variables: {
                    where: {
                        id: product.id,
                    },
                    data: {
                        productStatus: {
                            set:
                                product.productStatus === "Offline" ? "Published" : "Offline",
                        },
                    },
                },
            });
            updateManyDynoes({
                variables: {
                    where: {
                        id: { in: dynoes },
                    },
                    publisherId: publisher?.id,
                    data: {
                        dynoPublishingStatus: {
                            set:
                                product.productStatus === "Offline"
                                    ? "AddedToProductLine"
                                    : "VerifiedByQA",
                        },
                    },
                },
            });
            onClose();
        }
    };

    const onChangeLock = (value, listId, dynosUnderListId) => {
        setLoading(true)
        updateDynoListValue({
            variables: {
                where: {
                    id: listId,
                },
                data: {
                    dynosUnderList: {
                        update: {
                            where: {
                                id: dynosUnderListId,
                            },
                            data: {
                                isLocked: { set: value },
                            },
                        },
                    },
                },
            },
        });
    };

    const updateChapterListOrder = (fromIndex, toIndex) => {
        const updatedList = [...product.productContent.dynoList];
        const [movedItem] = updatedList.splice(fromIndex, 1);
        updatedList.splice(toIndex, 0, movedItem);
        setProduct((prev) => ({
            ...prev,
            productContent: {
                ...prev.productContent,
                dynoList: updatedList,
            },
        }));
        updateProduct({
            variables: {
                where: {
                    id: product.id,
                },
                data: {
                    productContent: {
                        update: {
                            dynoList: {
                                update: updatedList.map((dynList, index) => ({
                                    where: { id: dynList.id },
                                    data: { listIndex: { set: index + 1 } },
                                })),
                            },
                        },
                    },
                },
            },
        });
    };

    const archiveProduct = (product) => {
        setLoading(true)
        archiveProductItem({
            variables: {
                data: {
                    productStatus: {
                        set: REMOVED,
                    },
                },
                where: {
                    id: product.id,
                },
            },
        });
    }

    const addToStore = (product, value) => {
        if (product.productPricingType === "OneTimePurchase" && product.productOneTimePlans.length === 0) {
            toast({
                position: "top-right",
                title: `No price available. Please add pricing.`,
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
        } else if (product.productPricingType === "Subscription" && product.productSubscriptionPlans.length === 0) {
            toast({
                position: "top-right",
                title: `No price available. Please pricing.`,
                status: "warning",
                duration: 2000,
                isClosable: true,
            });
        } else {
            setLoading(true)
            addToStoreItem({
                variables: {
                    data: {
                        isAddedToStore: {
                            set: value,
                        },
                    },
                    where: {
                        id: product.id,
                    },
                },
            });
        }
    }
    const createPricePlan = (e) => {
        e.preventDefault()
        setLoading(true)
        if (pricePlan.type === SUBSCRIPTION) {
            createProductSubscription({
                variables: {
                    where: {
                        id: publisher.id,
                        productId: productId
                    },
                    data: {
                        planName: "Product Price",
                        planShortDescription: "Product Price",
                        price: pricePlan.price,
                        currency: USD,
                        frequency: pricePlan.frequency,
                        productPricingType: SUBSCRIPTION
                    },
                },
            });
        } else {
            createProductOneTimePlan({
                variables: {
                    where: {
                        id: publisher.id,
                        productId: product_Id,
                    },
                    data: {
                        planName: "Product Price",
                        planShortDescription: "Product Price",
                        planLongDescription: "Product Price",
                        price: pricePlan.price,
                        currency: USD,
                        productPricingType: ONETIMEPURCHASE
                    },
                },
            });
        }
    }

    const handleChange = (e) => {
        setPricePlan({
            ...pricePlan,
            [e.target.name]:
                e.target.name === "price" ? Number(e.target.value) : e.target.value,
        });
    };

    const searchTextCallback = useCallback((text) => {
        setSearchText(text);
    }, []);

    const currentDynosList = useMemo(() => {
        const firstPageIndex = (currentPage - 1) * PageSize;
        const lastPageIndex = firstPageIndex + PageSize;
        const resDynoes = dynoes.slice(firstPageIndex, lastPageIndex);
        if (!resDynoes[0]) {
          return [];
        } else {
          return resDynoes;
        }
      }, [currentPage, dynoes]);

      useEffect(() => {
        const timer = setTimeout(() => {
          if (searchText !== "") {
            searchMyDynoes({
              variables: {
                orderBy: {
                  createdAt: "desc",
                },
                take: 10,
                where: {
                  owner: {
                    id: {
                      equals: user.id,
                    },
                  },
                  dynoTitleNoCase: {
                    contains: searchText,
                  },
                },
              },
            });
          }
        }, 400);
        return () => {
          clearTimeout(timer);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [searchText]);

    return {
        catalogs,
        product,
        publishStatus,
        isAdmin,
        canProductBePublished,
        listTitle,
        showViewer,
        listId,
        dynosToAdd,
        iPadPortrait,
        isOpen,
        onOpen,
        onClose,
        isDynoModalOpen,
        onDynoModalClose,
        onDynoModalOpen,
        createNewChapter,
        lockUnlockAllDyno,
        updateChapterListOrder,
        deleteCallback,
        openAddDynoModal,
        updatDynoStatusCallback,
        updateDynoListCallback,
        onChangeLock,
        updatDynoAccessType,
        checkOnChange,
        addDynoToList,
        publishProduct,
        createAIChaptersName,
        productId,
        editCallback,
        deleteDynoCallback,
        archiveProduct,
        addToStore,
        loading,
        createMediaDynoCallback,
        isAddMediaModalOpen,
        onAddMediaModalOpen,
        onAddMediaModelClose,
        onMediaModalOpen,
        media,
        selectMedia,
        publisher,
        user,
        handleChange,
        createPricePlan,
        setPricePlan,
        pricePlan,
        isOpenAddPlan,
        onOpenAddPlan,
        onCloseAddPlan,
        showButton,
        onAddMediaClose,
        myDynoesLoading,
        dynoes,
        currentPage,
        totalDynoes,
        PageSize,
        onPageChange,
        searchText,
        currentDynosList,
        searchTextCallback,
        searchedDynoes,
        searchMyDynoesLoading
    }
}
